import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ProductListState } from "../../../features/view/public/productListPage/productlistingTypes";
import { fetchPeopleBaughtList, fetchProductList } from "./productListingAPI";

const initialState: ProductListState = {
  productsList: { data: [], loader: false, filters: [] },
  peopleBaughtList: { data: [], loader: false ,values:[]},
};

export const getProductListWithCategoryAsync = createAsyncThunk(
  "productList/get",
  async ({
    category_code,
    anonymous_id,
    tag_ids,
    dynamic_filter_ids,
  }: {
    category_code: string;
    anonymous_id: string | null;
    tag_ids?: number[];
    dynamic_filter_ids?: number[];
  }) => {
    const response = await fetchProductList({
      category_code,
      anonymous_id,
      tag_ids,
      dynamic_filter_ids,
    });

    return response;
  }
);

export const getPeopleBaughtListAsync = createAsyncThunk(
  "products/people_also_bought/",
  async ({
    anonymous_id,
    product_id,
  }: {
    anonymous_id: any;
    product_id: any;
  }) => {
    const response = await fetchPeopleBaughtList(anonymous_id, product_id);
    return response;
  }
);

export const productsListSlice = createSlice({
  name: "productList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getProductListWithCategoryAsync.pending, (state) => {
        state.productsList.loader = true;
      })
      .addCase(
        getProductListWithCategoryAsync.fulfilled,
        (state, action: any) => {
          state.productsList.loader = false;
          state.productsList.filters = action?.payload?.data?.filters || [];
          // state.productsList.data = action?.payload?.data || [];
          const data = action?.payload?.data?.data || [];
          const filteredProducts = data?.map((item: any) => {
            return {
              ...item,
              products: item?.products?.filter((product: any) => {
                // Check if there is at least one SKU with status "Visible"
                return product?.skus?.some(
                  (sku: { sku_status: string }) => sku?.sku_status === "Visible"
                );
              }),
            };
          });

          state.productsList.data = filteredProducts || [];
        }
      )
      .addCase(getProductListWithCategoryAsync.rejected, (state) => {
        state.productsList.loader = false;
      })
      .addCase(getPeopleBaughtListAsync.pending, (state) => {
        state.peopleBaughtList.loader = true;
      })
      .addCase(getPeopleBaughtListAsync.fulfilled, (state, action: any) => {
        state.peopleBaughtList.loader = false;
        state.peopleBaughtList.data = action?.payload?.data?.filters || [];
        state.peopleBaughtList.values = action?.payload?.data?.products || [];
        const data = action?.payload?.data?.data || [];
        const filteredProducts = data?.map((item: any) => {
          return {
            ...item,
            products: item?.products?.filter((product: any) => {
              // Check if there is at least one SKU with status "Visible"
              return product?.skus?.some(
                (sku: { sku_status: string }) => sku?.sku_status === "Visible"
              );
            }),
          };
        });

        state.peopleBaughtList.data = filteredProducts || [];
      })
      .addCase(getPeopleBaughtListAsync.rejected, (state) => {
        state.peopleBaughtList.loader = false;
      });
  },
});
// export const { } = productsListSlice.actions;

export default productsListSlice.reducer;
